import { render, staticRenderFns } from "./table-component.vue?vue&type=template&id=0394040d&scoped=true&"
import script from "./table-component.vue?vue&type=script&lang=js&"
export * from "./table-component.vue?vue&type=script&lang=js&"
import style0 from "./table-component.vue?vue&type=style&index=0&id=0394040d&scoped=true&lang=less&"
import style1 from "./table-component.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394040d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0394040d')) {
      api.createRecord('0394040d', component.options)
    } else {
      api.reload('0394040d', component.options)
    }
    module.hot.accept("./table-component.vue?vue&type=template&id=0394040d&scoped=true&", function () {
      api.rerender('0394040d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/compoment/table-component/table-component.vue"
export default component.exports